import { render, staticRenderFns } from "./DetectiveComponent.vue?vue&type=template&id=e356aa82&scoped=true&lang=pug&"
import script from "./DetectiveComponent.vue?vue&type=script&lang=js&"
export * from "./DetectiveComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetectiveComponent.vue?vue&type=style&index=0&id=e356aa82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356aa82",
  null
  
)

export default component.exports